export enum MetaTagKey {
  SANCUS_VERSION = 'sancus-version',
  TENANT_CONFIG = 'tenant-config',
  USER_LOGIN = 'user-login',
}

export enum SancusVersion {
  V3 = 'SANCUS_V3',
  V4 = 'SANCUS_V4',
}

export interface TenantConfigMeta {
  tenantName: string;
  tenantPortalTitle: string;
  stageName: string;
  tenantStage: string;
  assetsEntryUrl: string;
  cspAllowedOrigins: string[];
  authType: string;
  backendBaseUrl: string;
  enableCSRF: boolean;
}

export const getMetaTagContent = (key: MetaTagKey | string): string | null => {
  const meta = document.querySelector(`meta[name="${key}"]`);
  return meta?.getAttribute('content') || null;
};

export const isSancusV4 = (): boolean => {
  return getMetaTagContent(MetaTagKey.SANCUS_VERSION) === SancusVersion.V4;
};

export const getTenantConfigFromMeta = (): TenantConfigMeta | null => {
  const encoded = getMetaTagContent(MetaTagKey.TENANT_CONFIG);
  if (!encoded) return null;
  
  try {
    return JSON.parse(atob(encoded));
  } catch {
    return null;
  }
};

export const getUserLoginFromMeta = (): string | null => {
  return getMetaTagContent(MetaTagKey.USER_LOGIN);
};
